import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ComplianceCourseIddProgressModel } from 'src/app/models/compliance/compliance-course-idd-progress.model';

@Component({
  selector: 'app-compliance-competence-matrix',
  standalone: false,
  templateUrl: './compliance-competence-matrix.component.html',
  styleUrl: './compliance-competence-matrix.component.scss',
})
export class ComplianceCompetenceMatrixComponent {
  @Input()
  complianceIddProgress!: ComplianceCourseIddProgressModel;

  matrixData!: ComplianceMatrixSlice[];
  totalPersonsCount!: number;

  constructor(
    private translateService: TranslateService,
    private router: Router
  ) {
    this.customizeEmployeeChartText = this.customizeEmployeeChartText.bind(this);
    this.customizeEmployeeChartPoint = this.customizeEmployeeChartPoint.bind(this);
  }

  ngOnInit() {
    this.totalPersonsCount = this.complianceIddProgress.completedPersonIds.length
      + this.complianceIddProgress.startedPersonIds.length
      + this.complianceIddProgress.openPersonIds.length
      + this.complianceIddProgress.pendingPersonIds.length;

    this.matrixData = [
      {
        label: this.translateService.instant(
          'COMPLIANCE.COMPLIACE-PROGRESS-STATUSES.COMPLETED'
        ),
        // pending participants are treated as completed
        value: this.complianceIddProgress.completedPersonIds.length 
          + this.complianceIddProgress.pendingPersonIds.length,
        personIds: this.complianceIddProgress.completedPersonIds
          .concat(this.complianceIddProgress.pendingPersonIds),
        color: '#66cc66' // green
      },
      {
        label:  this.translateService.instant(
          'COMPLIANCE.COMPLIACE-PROGRESS-STATUSES.OPEN'
        ),
        value: this.complianceIddProgress.openPersonIds.length,
        personIds: this.complianceIddProgress.openPersonIds,
        color: '#f53d3d' // red
      },
      {
        label:  this.translateService.instant(
          'COMPLIANCE.COMPLIACE-PROGRESS-STATUSES.IN-PROGRESS'
        ),
        value: this.complianceIddProgress.startedPersonIds.length,
        personIds: this.complianceIddProgress.startedPersonIds,
        color: '#ffcc66' // yellow
      }
    ];
  }

  customizeEmployeeChartPoint(pointInfo: any) {
    return { 
      color: this.matrixData[pointInfo.index].color 
    }
  }

  customizeEmployeeChartText(arg: any) {
    const value = this.matrixData[arg.pointIndex].value;
    const percent = this.totalPersonsCount > 0 ? Math.round((value / this.totalPersonsCount) * 100) : 0;
    return `${arg.pointName}: ${value} (${percent}%)`;
  }

  onEmployeePointClick(event: any) {
    const persons = event.target.data.personIds;

    if (!persons?.length) {
      return;
    }

    this.router.navigate(['/employee'], {
      queryParams: { persons: JSON.stringify(persons) },
    });
  }
}

interface ComplianceMatrixSlice  {
  label: string;
  value: number;
  personIds: string[];
  color: string;
}